export default {
  choose_subject: "Seleccione una materia",
  show_lesson: "El curso",
  course: "Curso",
  lessonLink: "Enlace",
  activityDone: "Actividades realizadas",
  workToDo: "Trabajo por hacer",
  generalCourses: "Cursos generales",
  attachments: "Adjuntos",
  attachment: "Adjunto",
  download: "Descargar",
  "Taught subject": "Materia impartida",
  lesson_info:
    "Este menú permite configurar las asignaturas vinculadas a los diferentes módulos: calendario, competencias, boletín de calificaciones.",
  lesson_search_label: "Buscar un curso o una materia",
  lesson_search_placeholder: "Palabras clave: curso, materia...",
  lesson_search_reset: "Borrar la búsqueda",
  lesson_search_no_result: "Ningún curso coincide con su búsqueda",
  lessons_count: ({ plural }) => plural(["curso", "cursos"]),
  lesson_search_results_count: ({ plural, named }) =>
    plural([`${named("count")} curso encontrado`, `${named("count")} cursos encontrados`]),
};
